import useCatalogListFilter from '../../../filter/useCatalogListFilter';
import { CatalogListFiltersProviderProps } from '../catalogListPage.types';

const CatalogListPageFilters = ({ children }: CatalogListFiltersProviderProps) => {
  const filters = useCatalogListFilter();

  return children(filters);
};

export default CatalogListPageFilters;
